import configDevelopment from './config-development.js';
import configStaging from './config-staging.js';
import configProduction from './config-production.js';
import configUAT from './config-uat.js';
import clientConfig from './clientConfig';

let config = null;
const ENV = process.env.REACT_APP_BUILD_ENV;
console.log('ENV', ENV);

if (ENV === 'development') {
  config = configDevelopment;
} else if (ENV === 'staging') {
  config = configStaging;
} else if (ENV === 'production') {
  config = configProduction;
} else if (ENV === 'uat') {
  config = configUAT;
} else {
  config = configDevelopment;
}
export default config;

// Cashfree SDK environment.
//
// A `payment_session_id` minted with sandbox credentials is only valid against
// the sandbox gateway, and vice versa. Mixing them fails with
// `payment_session_id_invalid`, so this has to track whichever backend the build
// points at: only a production build talks to a production backend.
export const CASHFREE_MODE = ENV === 'production' ? 'production' : 'sandbox';

export const SERVICE_LINE_NAMES = {
  LABS: 'labs',
  PHARMACY: 'pharmacy',
  TELE: 'tele',
  DENTAL: 'dental',
  OFFLINE: 'offline',
  PREBOOK: 'prebook',
  SEARCHBOOK: 'searchAndBook',
  VISION: 'vision',
  PHYSIO: 'physio',
};

// Prod
export const ahcConditionalSponsorIds = {
  qualcommSponsorId: 11510,
  evokeSponsorId: 17475,
  axisSponsorId: 311,
};

// Prod
export const claimsCategoryId = {
  ahcId: 28,
};

export const showPaperFormPackageIds = [8475, 8401];

export const myntraSponsorId = clientConfig.myntraSponsorIds || [18769];

// Per-client gate for the "For You" tab in lab-test Smart Report.
// Empty array (default) = unrestricted (tab shown for all sponsors).
// Non-empty = tab shown only for the listed sponsorIds.
export const showForYouSection = clientConfig.showForYouSection || [];

export const REIMBURSEMENT_REASONS = {
  NON_SERVICEABLE_AREA: 'NON_SERVICEABLE_AREA',
  CHILD_BELOW_5: 'CHILD_BELOW_5',
};
